import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {}

export const affiliateLocationSlice = createSlice({
  name: 'affiliate_Location',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    initializeAffiliateLocation: () => initialState,
    setAffiliateLocation: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    }
  }
})

export const { initializeAffiliateLocation, setAffiliateLocation } = affiliateLocationSlice.actions

export default affiliateLocationSlice.reducer
